import { atom, selector } from "recoil";

export const isPracticeState = atom({
  key: "isPracticeState",
  default: false,
});

export const trialState = atom({
  key: "hasCompletedTrialState",
  default: false,
})

export const practiceVideoSrcState = atom({
  key: "practiceVideoSrcState",
  default: null,
});

export const isSettingModalOpenState = atom({
  key: "isSettingModalOpenState",
  default: true,
});

export const isUploadingState = atom({
  key: "isUploadingState",
  default: false,
});

export const isRecordingState = atom({
  key: "isRecordingState",
  default: false,
});

export const isStreamingState = atom({
  key: "isStreamingState",
  default: false,
});

export const deviceListState = atom({
  key: "deviceListState",
  default: [],
});

export const volumeState = atom({
  key: "volumeState",
  default: 0.0,
});

export const selectedDeviceState = atom({
  key: "selectedDeviceState",
  default: {
    audio: {
      deviceId: "default",
    },
  },
});

export const isVideoState = atom({
  key: "isVideoState",
  default: 0,
});

export const streamState = atom({
  key: "streamState",
  default: null,
});

export const recorderState = atom({
  key: "recorderState",
  default: null,
});



// export const micState = atom({
//   key: "micState",
//   default: navigator.permissions
//     .query({ name: "microphone" })
//     .then((result) => {
//       console.log(result)
//       result.onchange = () => {
//         return result;
//       };
//       return result;
//     }),
// });

export const micState = atom({
  key: "micState",
  default: null
})

// export const micState = atom({
//   key: "micState",
//   default:
//   navigator.mediaDevices
//     .getUserMedia({ audio: true })
//     .then((stream) => {
//       console.log(stream)
//       stream.getTracks().forEach((track) => track.stop());
//       return { state: "granted" };
//     })
//     .catch((error) =>
//       error.name === "NotAllowedError" ? { state: "denied" } : { state: "prompt" }
//     )
// })

// const isPermissionsSupported = () =>
//   "permissions" in navigator && "query" in navigator.permissions;

// const testMicPermission = () =>
//   navigator.mediaDevices
//     .getUserMedia({ audio: true })
//     .then((stream) => {
//       console.log(stream)
//       stream.getTracks().forEach((track) => track.stop());
//       return { state: "granted" };
//     })
//     .catch((error) =>
//       error.name === "NotAllowedError" ? { state: "denied" } : { state: "prompt" }
//     );

// export const micState = atom({
//   key: "micState",
//   default: new Promise((resolve) => {
//     console.log(isPermissionsSupported())
//     if (isPermissionsSupported()) {
//       navigator.permissions
//         .query({ name: "microphone" })
//         .then((result) => {
//           console.log(result)
//           result.onchange = () => result;
//           resolve(result);
//         })
//         .catch(() => testMicPermission().then(resolve));
//     } else {
//       testMicPermission().then(resolve);
//     }
//   }),
// });

// const testCamPermission = () =>
//   navigator.mediaDevices
//     .getUserMedia({ video: true })
//     .then((stream) => {
//       stream.getTracks().forEach((track) => track.stop());
//       return { state: "granted" };
//     })
//     .catch((error) =>
//       error.name === "NotAllowedError" ? { state: "denied" } : { state: "prompt" }
//     );

// export const camState = atom({
//   key: "camState",
//   default: new Promise((resolve) => {
//     if (isPermissionsSupported()) {
//       navigator.permissions
//         .query({ name: "camera" })
//         .then((result) => {
//           console.log(result)
//           result.onchange = () => result;
//           resolve(result);
//         })
//         .catch(() => testCamPermission().then(resolve));
//     } else {
//       testCamPermission().then(resolve);
//     }
//   }),
// });

export const inputDeviceGroupState = atom({
  key: "inputDeviceGroupState",
  default: null,
});
